/* eslint-disable max-len */
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { FlexLayoutConfig } from './FlexLayout';
import { FlexLayoutConfigWidget } from './FlexLayoutConfigWidget';

const Layout = styled.div`
    display: grid;
    grid-template-columns: 4rem repeat(3, 1fr);
    grid-auto-rows: 1fr;
    gap: .5rem; 
`;

export const AutoLayoutConfigWidget = ({ widget }: { widget: PopoutWidget }) => {

    const value = useObserver(widget).value ?? [];
    const [mode] = value;
    const config = FlexLayoutConfig.from(mode === 'flex' ? value.slice(1) : ['none']);

    const onChangeConfig = useCallback((next: any[]) => {
        widget.update({ value: ['flex', ...next] });
    }, [value]);

    return <Flexer flex="column" width="16" padding=".5" gap=".25">
        <Layout>
            <FlexLayoutConfigWidget value={config} onChange={onChangeConfig} />
        </Layout>
    </Flexer>;
};
